export default (entities) => {
  entities.forEach((entity) => {
    entity.fields.sort(
      (a, b) => (a.order || 0) - (b.order || 0),
    );
  });

  entities.sort((a, b) => (a.order || 0) - (b.order || 0));

  return entities;
};
